import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { bindActionCreators, Dispatch } from "redux";
import { Market } from "model/market";
import { connect } from "react-redux";
import { updateMarketReport } from "redux/slice/market-reports";
import { SaveButton } from "component/shared/save-button";
import { RootState } from "redux/store";
import { styles } from "./style";
import * as yup from "yup";
import { validate } from "shared/yup";
import { User } from "model/user";

interface Props extends 
	ReturnType<typeof mapDispatchToProps>,
	ReturnType<typeof mapStateToProps>,
	WithStyles<typeof styles> {
		market: Market;
		user: User;
	}

interface State {
	customUrl: string;
	webIntroText: string, 
	emailIntroText: string, 
	navigationDisplay: boolean,
	saved: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	updateMarketReport,
}, dispatch);

const mapStateToProps = (state: RootState) => {
	return {
		loading: state.marketReports.loading 
	};
}

class Component extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		const { market } = this.props
		const report = market.marketReport;
		this.state = {
			customUrl: report && report.customUrl ? report.customUrl : "",
			webIntroText: report && report.webpageIntroText ? report.webpageIntroText : "",
			emailIntroText: report && report.emailIntroText ? report.emailIntroText : "",
			navigationDisplay: !!(report && report.displayInNavigation),
			saved: false,
		}
	}

	private save() {
		const { market } = this.props;
		const { emailIntroText, navigationDisplay, webIntroText, customUrl } = this.state;
		const errors = validate(this.validationSchema, this.state);
		if (market.marketReport && !errors) {
			this.props.updateMarketReport({ marketReport: {
				...market.marketReport,
				displayInNavigation: navigationDisplay,
				emailIntroText: emailIntroText,
				webpageIntroText: webIntroText,
				customUrl: customUrl,
			}});
		}
	}

	private validationSchema = {
		customUrl: yup
			.string()
			.url("Please enter a valid URL"),
	};

	render() {
		const { user, market, loading, classes = {} } = this.props;
		const { emailIntroText, navigationDisplay, saved, webIntroText, customUrl } = this.state;
		const errors = validate(this.validationSchema, this.state);
		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item >
					<Mui.Grid container direction="row" justifyContent="space-between" wrap="nowrap">
						<Mui.Grid item xs={2}>
							<Mui.Typography>Page URL</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item xs={9}>
							<Mui.Link
								href={market.marketReport?.pageUrl}
								target="_blank"
							>{market.marketReport?.pageUrl}</Mui.Link>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				{user.permissions.plugin && user.permissions.marketReport && (
					<Mui.Grid item >
						<Mui.Grid container direction="row" justifyContent="space-between" wrap="nowrap">
							<Mui.Grid item xs={2}>
								<Mui.Typography>Custom URL</Mui.Typography>
							</Mui.Grid>
							<Mui.Grid item xs={9}>
								<Mui.TextField
									error={saved && errors && !!errors.customUrl}
									helperText={saved && errors && errors.customUrl}
									fullWidth
									size="small"
									variant="outlined"
									value={customUrl}
									onChange={(event) => this.setState({customUrl: event.target.value})}
								/>
							</Mui.Grid>
						</Mui.Grid>
					</Mui.Grid>	
				)}
				<Mui.Grid item >
					<Mui.Grid container direction="row" justifyContent="space-between" wrap="nowrap">
						<Mui.Grid item xs={2}>
							<Mui.Typography>Webpage Intro Text</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item xs={9}>
							<Mui.TextField
								multiline
								minRows={5}
								variant="outlined"
								fullWidth
								value={webIntroText}
								onChange={(event) => {
									this.setState({webIntroText: event.target.value})
								}}
							/>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.Grid container direction="row" justifyContent="space-between" wrap="nowrap">
						<Mui.Grid item xs={2}>
							<Mui.Typography>Email Intro Text</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item xs={9}>
							<Mui.TextField
								multiline
								minRows={5}
								variant="outlined"
								fullWidth
								value={emailIntroText}
								onChange={(event) => {
									this.setState({emailIntroText: event.target.value})
								}}
							/>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.Grid container direction="row" justifyContent="space-between" wrap="nowrap">
						<Mui.Grid item xs={2}>
							<Mui.Typography>Display in Navigation</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item xs={9}>
							<Mui.Checkbox
								checked={navigationDisplay}
								onChange={(event) => {
									this.setState({navigationDisplay: !navigationDisplay})
								}}
							/>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				<Mui.Grid item className={classes.saveRow}>
					<SaveButton 
						error={saved && errors ? "Please check the market report form for errors" : undefined}
						loading={!!loading && saved} 
						label={{
							primary: "Save", 
							inProgress: "Saving...", 
							completed: "Saved" 
						}}
						snackBar={true}
						onClick={() => {
							this.setState({saved: true});
							this.save();
						}}
						onReset={() => this.setState({saved: false})} 
					/>
				</Mui.Grid>
			</Mui.Grid>
		)
	}
}

export const MarketReportContent = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);